function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable no-underscore-dangle */
import React from 'react';
import cn from 'classnames';
import { string, shape, arrayOf, bool } from 'prop-types';
import SocialFollow from '../../molecules/SocialFollow';
import Image from '../../atoms/Image';
import CorporateLogo from '../../atoms/CorporateLogo';
import List from '../../molecules/List';
import Link from '../../atoms/Link';
import MenuLink from '../../atoms/MenuLink';
import BackgroundContainer from '../../atoms/BackgroundContainer';
/**
 * SiteFooter component.
 */

var SiteFooter = function SiteFooter(_ref) {
  var className = _ref.className,
      socialFollow = _ref.socialFollow,
      logo = _ref.logo,
      company = _ref.company,
      partnerLogo = _ref.partnerLogo,
      menuItems = _ref.menuItems,
      copyrightText = _ref.copyrightText,
      consentProvider = _ref.consentProvider,
      sourcepoint = _ref.sourcepoint,
      logoUrl = _ref.logoUrl;
  var cmpEnabled = (sourcepoint === null || sourcepoint === void 0 ? void 0 : sourcepoint.enabled) || consentProvider;
  var footerMenu = [].concat(_toConsumableArray(menuItems), [cmpEnabled && {
    label: 'Manage Privacy Settings',
    relativeUrl: '#',
    title: 'Manage your privacy and consent settings',
    onClick: function onClick(evt) {
      var _window$_sp_;

      evt.preventDefault();

      if ((sourcepoint === null || sourcepoint === void 0 ? void 0 : sourcepoint.enabled) && ((_window$_sp_ = window._sp_) === null || _window$_sp_ === void 0 ? void 0 : _window$_sp_.gdpr)) {
        window._sp_.gdpr.loadPrivacyManagerModal(sourcepoint === null || sourcepoint === void 0 ? void 0 : sourcepoint.settingsUiId);

        return;
      }

      if (!/.*quantcast.*/.test(consentProvider)) {
        throw new Error("Unknown consent provider: \"".concat(consentProvider, "\""));
      }

      if (consentProvider.includes('v2')) {
        window.__tcfapi('displayConsentUi', 2, function () {});
      } else {
        window.__cmp('displayConsentUi', null, !0);
      }
    }
  }]).filter(function (x) {
    return x;
  });
  var companyText = (company === null || company === void 0 ? void 0 : company.name) ? " ".concat(company.name, " ") : null;
  var getCopyrightYearText = (companyText || ' Immediate Media Company Ltd. ') + new Date().getFullYear();
  return /*#__PURE__*/React.createElement("footer", {
    className: cn('site-footer hidden-print', className),
    "data-feature": "FooterNavigation"
  }, /*#__PURE__*/React.createElement(BackgroundContainer, {
    className: "site-footer__brand-section",
    hasTopBorder: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "site-footer__flex-row site-footer__flex-row--center container chromatic-ignore"
  }, logo && /*#__PURE__*/React.createElement(Image, _extends({
    fluid: true,
    className: "site-footer__brand-logo",
    maxWidth: 220,
    maxHeight: 40
  }, logo, {
    srcSetBreakpoints: [220, 440, 660, 880 // Up to 4x the max width
    ],
    sizes: ['220px'],
    link: {
      href: logoUrl,
      rel: 'home'
    }
  })), socialFollow && /*#__PURE__*/React.createElement("div", {
    className: "site-footer__social-follow"
  }, /*#__PURE__*/React.createElement(SocialFollow, socialFollow)))), /*#__PURE__*/React.createElement(BackgroundContainer, {
    className: "site-footer__corporate-section"
  }, /*#__PURE__*/React.createElement("section", {
    className: "site-footer__corporate-section-inner body-copy-small fluid-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "site-footer__flex-row container chromatic-ignore"
  }, menuItems.length > 1 && /*#__PURE__*/React.createElement(List, {
    className: "site-footer__menu"
  }, footerMenu.map(function (item, index) {
    return /*#__PURE__*/React.createElement(List.Item, {
      key: "".concat(item.label, "-").concat(item.relativeUrl || item.absoluteUrl),
      className: "site-footer__menu-item",
      "data-component": "MenuLink",
      "data-index": index + 1,
      "data-item-name": item.label
    }, /*#__PURE__*/React.createElement(MenuLink, _extends({
      inverted: true,
      className: "site-footer__menu-link"
    }, Object.assign(item, {
      children: null
    })), item.label));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "site-footer__flex-row container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "site-footer__corporate-logo chromatic-ignore"
  }, company && /*#__PURE__*/React.createElement(Link, {
    href: company.url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(CorporateLogo, {
    name: company.name,
    logo: company.logo,
    width: 100,
    fillColor: "baseWhite"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "site-footer__copyright-section"
  }, copyrightText && /*#__PURE__*/React.createElement("small", {
    className: "site-footer__copyright-text body-copy-small"
  }, copyrightText), /*#__PURE__*/React.createElement("small", {
    className: "site-footer__copyright-text body-copy-small mt-xs"
  }, "\xA9", getCopyrightYearText)), partnerLogo && /*#__PURE__*/React.createElement(Image, _extends({
    fluid: true,
    className: "site-footer__partner-logo"
  }, partnerLogo, {
    maxWidth: 80,
    srcSetBreakpoints: [80, 160, 240, 320 // Up to 4x the max width
    ],
    sizes: ['80px']
  }))))));
};

SiteFooter.defaultProps = {
  socialFollow: null,
  className: null,
  logo: null,
  partnerLogo: null,
  company: {
    logo: null,
    url: 'https://www.immediate.co.uk',
    name: null
  },
  menuItems: [],
  copyrightText: null,
  consentProvider: null,
  logoUrl: null,
  sourcepoint: null
};
SiteFooter.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,

  /** The social follow options. */
  socialFollow: shape(SocialFollow.propTypes),

  /** The brand logo. */
  logo: shape(Image.propTypes),

  /** The corporate brand logo. */
  company: shape({
    logo: shape(Image.propTypes),
    url: string,
    name: string
  }),

  /** The partner brand logo. */
  partnerLogo: shape(Image.propTypes),

  /** List of links for standard site hygiene footer */
  menuItems: arrayOf(shape(MenuLink.propTypes)),

  /** Copyright text on the footer. Excludes date */
  copyrightText: string,

  /** Shows a link for the manage cookies */
  consentProvider: string,

  /** Sourcepoint settings */
  sourcepoint: shape({
    sourcepoint: shape({
      settingsUiId: string,
      enabled: bool
    })
  }),

  /** The URL to link to from any brand logos. */
  logoUrl: string
} : {};
export default SiteFooter;